import { collection, getDocs, query, orderBy, where, doc, setDoc } from 'firebase/firestore';
import { db } from '../firebase';

/**
 * Firestore'dan tüm dersleri çeker
 * Dersler sectionId'ye göre sıralanır, section içindeki sırayı JS tarafında order alanına göre yapar
 */
export const getAllLessons = async () => {
  try {
    const lessonsRef = collection(db, 'lessons');
    const q = query(lessonsRef, orderBy('sectionId'));
    const snapshot = await getDocs(q);

    const lessons = [];
    snapshot.forEach((docSnap) => {
      lessons.push({
        id: docSnap.id,
        ...docSnap.data()
      });
    });

    return lessons;
  } catch (error) {
    console.error('Error getting lessons:', error);
    throw error;
  }
};

/**
 * Belirli bir sectionId için dersleri getirir
 */
export const getLessonsBySection = async (sectionId) => {
  try {
    const lessonsRef = collection(db, 'lessons');
    const q = query(
      lessonsRef,
      where('sectionId', '==', sectionId),
      orderBy('order')
    );
    const snapshot = await getDocs(q);

    const lessons = [];
    snapshot.forEach((docSnap) => {
      lessons.push({
        id: docSnap.id,
        ...docSnap.data()
      });
    });

    return lessons;
  } catch (error) {
    console.error('Error getting lessons by section:', error);
    throw error;
  }
};

/**
 * Dersleri section'lara göre gruplayıp döndürür
 */
export const getLessonsGroupedBySection = async () => {
  try {
    const lessons = await getAllLessons();

    const grouped = {};
    lessons.forEach((lesson) => {
      const sectionId = lesson.sectionId;
      if (!grouped[sectionId]) {
        grouped[sectionId] = {
          id: sectionId,
          title: lesson.sectionTitle,
          lessons: []
        };
      }
      grouped[sectionId].lessons.push(lesson);
    });

    return Object.values(grouped)
      .sort((a, b) => a.id - b.id)
      .map((section) => ({
        ...section,
        lessons: section.lessons.sort(
          (lessonA, lessonB) => (lessonA.order || 0) - (lessonB.order || 0)
        )
      }));
  } catch (error) {
    console.error('Error grouping lessons:', error);
    throw error;
  }
};

